// Guided skin-capture is now THE selfie-capture flow (it replaces the native
// camera-roll step in selfie -> analysis). So it's ON by default. This is kept
// only as a per-device kill-switch for testing: if the guided camera misbehaves
// on a given device, force the old native camera input without a redeploy via
//   localStorage.setItem('sonmi_guided_capture', '0')
// or disable it for a whole build with REACT_APP_GUIDED_CAPTURE=0.
// Live tuning overlay: shows the raw signal values + which checks pass, so
// thresholds can be tuned on a real device instead of by guesswork. Off unless
// localStorage.sonmi_capture_debug='1' (or REACT_APP_CAPTURE_DEBUG=1).
export function isCaptureDebugEnabled() {
  try {
    const ls =
      typeof window !== 'undefined' &&
      window.localStorage?.getItem('sonmi_capture_debug');
    if (ls === '1' || ls === 'true') return true;
    if (ls === '0' || ls === 'false') return false;
  } catch (_) {
    /* ignore */
  }
  return process.env.REACT_APP_CAPTURE_DEBUG === '1';
}

// Face-mesh overlay (v3). ON by default; kill per-device with
// localStorage.sonmi_mesh='0' if it feels distracting on a device.
export function isMeshOverlayEnabled() {
  try {
    const ls = typeof window !== 'undefined' && window.localStorage?.getItem('sonmi_mesh');
    if (ls === '0' || ls === 'false') return false;
    if (ls === '1' || ls === 'true') return true;
  } catch (_) {
    /* ignore */
  }
  return process.env.REACT_APP_MESH_OVERLAY !== '0';
}

// Force the single straight-on shot (v0 behavior) instead of the full
// multi-angle scan — per-device via localStorage.sonmi_capture_single='1'.
export function isSingleShotMode() {
  try {
    const ls = typeof window !== 'undefined' && window.localStorage?.getItem('sonmi_capture_single');
    return ls === '1' || ls === 'true';
  } catch (_) {
    return false;
  }
}

export function isGuidedCaptureEnabled() {
  try {
    const ls =
      typeof window !== 'undefined' &&
      window.localStorage?.getItem('sonmi_guided_capture');
    if (ls === '0' || ls === 'false') return false;
    if (ls === '1' || ls === 'true') return true;
  } catch (_) {
    /* localStorage blocked (private mode / SSR) — fall through */
  }
  return process.env.REACT_APP_GUIDED_CAPTURE !== '0';
}
